<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
  },
  data() {
    return {
      chart: null,
      date: [],
      isMB: this.$store.state.isMB,
      option: {
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              // 设置x轴颜色
              color: '#333'
            }
          }
        },
        grid: {
            top: '8%',
            left: "3%",
            right: "4%",
            bottom: "14%",
            containLabel: true
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              // 设置y轴颜色
              color: '#333'
            }
          }
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: false,
            areaStyle: {
              color: "#22aa88"
            },
            label: {
              show: true,
            },
            symbolSize: 6,
            itemStyle:{
              normal:{
                // 拐点上显示数值
                label : {
                  show: true
                },
                color: "#009966",
                borderColor:'#009966',  // 拐点边框颜色
                lineStyle:{                 
                  width: 2,  // 设置线宽
                  type:'solid',  //'dotted'虚线 'solid'实线
                  color: "#009966"
                }
              }
            }
          },
        ],
      },
    };
  },
  mounted() {
    // this.initChart();
    // let self = this;
    // setInterval(function () {
    //   self.initChart();
    // }, 60000);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data=[]) {
    //  if(!data.length) {
    //     data = [
    //       { Name: "7-10", Value: 3200 },
    //       { Name: "7-09", Value: 2200 },
    //       { Name: "7-08", Value: 3600 },
    //       { Name: "7-07", Value: 1800 },
    //       { Name: "7-06", Value: 3800 },
    //       { Name: "7-05", Value: 4200 },
    //       { Name: "7-04", Value: 2800 },
    //     ]
    //   }
      this.date = [];
      for (var i = 0; i < data.length; i++) {
        this.option.series[0].data[i] = data[data.length - 1 - i].Value;
        this.date.push(data[data.length - 1 - i].Name);
      }
      if(this.isMB) {
        this.option.grid.top = '15%';
        this.option.grid.left = '0%';
        this.option.grid.right = '0%';
      }
      this.option.xAxis.data = this.date;
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(this.option);
    },
  },
};
</script>
<style lang="scss">
.chart {
  @media screen and (max-width: 767px) {
    margin-top: -30px;
  }
}
</style>